import { ReactNode } from "react";
import Sidebar from "./Sidebar";
import Loader from "../utils/Loader";

type PageLayoutProps = {
  isLoading?: boolean;
  children: ReactNode;
  className?: string;
};

const PageLayout = ({ isLoading, children, className }: PageLayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex">
      <Sidebar />
      <div className="flex-1">
        <div className="max-w-screen md:max-w-[calc(100vw-250px)] h-screen overflow-y-auto">
          <div
            className={`pb-[200px] p-1 md:p-6 container mx-auto space-y-8 ${className}`}
          >
            {isLoading ? (
              <div className="flex justify-center items-center w-full h-[70dvh]">
                <Loader className="w-8 h-8 animate-spin" />
              </div>
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
